// Canonical Bevel Commercial Services offerings.
// Source of truth: BCS-WWD.pdf (latest version provided by the client).

import {
    HardHat,
    Hammer,
    Layers3,
    Zap,
    Wrench,
    PaintBucket,
    CloudRain,
    Building2,
    ClipboardCheck,
} from "lucide-react";

export const SERVICE_CATEGORIES = [
    {
        id: "construction",
        eyebrow: "I. Construction & Structural",
        title: "Construction & Structural Services",
        icon: HardHat,
        summary:
            "Ground-up construction and structural work, the foundation of every Bevel project.",
        groups: [
            {
                icon: ClipboardCheck,
                title: "General Contracting",
                items: [
                    "Ground-up construction",
                    "Project coordination & scheduling",
                    "Subcontractor management",
                    "Quality control & site supervision",
                ],
            },
            {
                icon: Hammer,
                title: "Structural & Framing",
                items: [
                    "Wood & metal framing",
                    "Structural modifications",
                    "Additions & expansions",
                ],
            },
            {
                icon: Layers3,
                title: "Concrete & Site Work",
                items: [
                    "Foundations & slabs",
                    "Sidewalks & walkways",
                    "Parking areas & pads",
                    "Site preparation & grading coordination",
                ],
            },
        ],
    },
    {
        id: "systems",
        eyebrow: "II. Systems & Infrastructure",
        title: "Systems & Infrastructure",
        icon: Zap,
        summary:
            "Mechanical, electrical, plumbing, and roofing delivered to commercial code and schedule.",
        groups: [
            {
                icon: Zap,
                title: "Mechanical, Electrical & Plumbing (MEP)",
                items: [
                    "Electrical installation & upgrades",
                    "Lighting systems",
                    "Plumbing installation & repairs",
                    "HVAC installation & service",
                    "System integration for commercial projects",
                ],
            },
            {
                icon: CloudRain,
                title: "Roofing Systems",
                items: [
                    "TPO, PVC & flat roofing systems",
                    "Roof repairs & leak detection",
                    "Roof replacements & upgrades",
                    "Flashing, penetrations & drainage systems",
                ],
            },
        ],
    },
    {
        id: "renovation",
        eyebrow: "III. Renovation & Finishing",
        title: "Renovation & Finishing",
        icon: PaintBucket,
        summary:
            "From tenant improvements to interior finishes, the work that lifts property value.",
        groups: [
            {
                icon: Building2,
                title: "Remodels & Renovations",
                items: [
                    "Commercial build-outs",
                    "Office & retail renovations",
                    "Residential remodels",
                    "Tenant improvements",
                    "Structural and layout modifications",
                ],
            },
            {
                icon: Wrench,
                title: "Interior Finishes",
                items: [
                    "Drywall installation & finishing",
                    "Interior & exterior painting",
                    "Trim & carpentry",
                    "Flooring coordination",
                ],
            },
        ],
    },
];
